import React from 'react';
import { Typography } from '@mui/material';
import { useStyles } from './LabelWithIcon.styles';

interface LabelWithIconProps {
  label: string;
  icon?: React.ReactNode;
  labelStyle?: Object;
}

const LabelWithIcon = ({ label, icon, labelStyle }: LabelWithIconProps) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      {icon && <span>{icon}</span>}
      <Typography
        variant="h3"
        className={classes.label}
        style={labelStyle ? labelStyle : {}}
      >
        {label}
      </Typography>
    </div>
  );
};

export default LabelWithIcon;
